import { FC, useEffect } from 'react';
import { UserListActionComponentProps } from '../UsersList/UserListActionComponent';
import { useUsersListSlice } from '@restore/usersList/usersList.slice';

type ResendInvitationProps = {
  currentUser: UserListActionComponentProps['currentUser'];
  onClose: () => void;
};
export const ResendInvitation: FC<ResendInvitationProps> = ({
  currentUser,
  onClose,
}) => {
  const doUserAction = useUsersListSlice((state, actions) => actions.doUser);
  useEffect(() => {
    if (currentUser) {
      doUserAction({ user: currentUser, actionName: 'resendInvitation' });
    }
    onClose();
  }, [currentUser, onClose]);
  return null;
};
